import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { Input } from './ui/input';
import { X, Check } from 'lucide-react';

const valid = (e) => /\S+@\S+\.\S+/.test(e);

export function CcPicker({ value, onChange }) {
  const [members, setMembers] = useState([]);
  const [extra, setExtra] = useState('');

  useEffect(() => {
    api.listTeamMembers()
      .then(r => setMembers((r.data || []).filter(m => m.role !== 'ac_member' && (m.email || '').trim())))
      .catch(() => {});
  }, []);

  const toggle = (email) => {
    const e = email.toLowerCase();
    onChange(value.includes(e) ? value.filter(v => v !== e) : [...value, e]);
  };

  const memberEmails = members.map(m => m.email.toLowerCase());
  const extras = value.filter(v => !memberEmails.includes(v));

  const addExtra = () => {
    const parts = extra.split(/[,;\s]+/).map(s => s.trim().toLowerCase()).filter(Boolean);
    const good = parts.filter(p => valid(p) && !value.includes(p));
    const bad = parts.filter(p => p && !valid(p));
    if (good.length) onChange([...value, ...good].slice(0, 10));
    setExtra(bad.join(', '));
  };

  return (
    <div className="space-y-1.5" data-testid="cc-picker">
      {members.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {members.map(m => {
            const sel = value.includes(m.email.toLowerCase());
            return (
              <button key={m.id} type="button" onClick={() => toggle(m.email)} data-testid={`cc-member-${m.id}`}
                title={m.email}
                className={`inline-flex items-center gap-1 text-[10px] border rounded-sm px-2 py-1 transition-colors ${sel
                  ? 'border-emerald-500/60 bg-emerald-600/15 text-emerald-200'
                  : 'border-border bg-secondary/40 text-muted-foreground hover:text-foreground'}`}>
                {sel && <Check className="w-3 h-3" />}{m.name || m.email}
              </button>
            );
          })}
        </div>
      )}
      <Input value={extra} onChange={e => setExtra(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addExtra(); } }}
        onBlur={addExtra}
        placeholder="Other CC address… (Enter or comma to add)" data-testid="cc-extra-input"
        className="bg-secondary border-border text-foreground rounded-sm h-7 text-xs" />
      {extras.length > 0 && (
        <div className="flex flex-wrap gap-1" data-testid="cc-extra-chips">
          {extras.map(e => (
            <span key={e} className="inline-flex items-center gap-1 text-[10px] font-mono border border-emerald-600/40 bg-emerald-600/10 text-emerald-300 rounded px-1.5 py-0.5">
              {e}
              <button type="button" onClick={() => onChange(value.filter(v => v !== e))}
                data-testid={`cc-remove-${e}`} className="hover:text-foreground">
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      )}
      {value.length > 0 && (
        <p className="text-[10px] text-muted-foreground" data-testid="cc-summary">
          {value.length} CC recipient{value.length === 1 ? '' : 's'} on every outgoing email (max 10).
        </p>
      )}
    </div>
  );
}
